import styled from "styled-components"

const Title = styled.div`
  font-size: ${(props) => props.theme.titleFontSize};
  margin-bottom: 15px;
`

export default Title
